import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { content } from '@/content/sr';
import { CONTACT_FORM_PATH } from '@/constants/paths';

const Hero = () => {
  return (
    <section 
      className="relative min-h-[90vh] flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Moderni enterijer"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/80 to-transparent" />
      </div>

      {/* Content */}
      <div className="container-custom relative z-10">
        <div className="max-w-2xl">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="caption text-brand-accent block mb-4"
          >
            {content.hero.caption}
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading text-5xl md:text-7xl font-light tracking-tight text-brand-primary mb-6"
          >
            {content.hero.title}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-neutral-700 leading-relaxed mb-10 max-w-xl"
          >
            {content.hero.subtitle}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <Link 
              to={CONTACT_FORM_PATH} 
              className="btn-accent text-center"
              data-testid="hero-cta-primary"
            >
              {content.hero.cta}
            </Link>
            <Link 
              to="/proizvodi" 
              className="btn-secondary text-center"
              data-testid="hero-cta-secondary"
            >
              {content.hero.ctaSecondary}
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  );
};

export default Hero;
